// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3yxVk","clinicsSelect":"TableHeading_clinicsSelect__X90EU"};